export default "__VITE_ASSET__BfAFz2Lz__"